import { BreakpointObserver, Breakpoints } from '@angular/cdk/layout';
import { DOCUMENT, isPlatformBrowser } from '@angular/common';
import {
  ChangeDetectorRef,
  Component,
  Inject,
  OnDestroy,
  OnInit,
  Optional,
  PLATFORM_ID,
} from '@angular/core';
import { FormControl } from '@angular/forms';
import { NavigationExtras, Router } from '@angular/router';
import { CarrentFilters } from '@app/models/carrent/CarrentFilters';
import { FerienFIlters } from '@app/models/filtermodels/FerienFIlters';
import { KreuzfahrtFilters } from '@app/models/filtermodels/KreuzfahrtFilters';
import { ParamFilters } from '@app/models/filtermodels/ParamFilters';
import { Partner } from '@app/models/partner/IPartner';
import { AuthGuardService } from '@app/services/auth-guard.service';
import { EncryptionService } from '@app/services/encyption.service';
import { PartnerService } from '@app/services/partner.service';
import { SearchService } from '@app/services/search.service';
import { TranslateService } from '@app/services/translate/translate.service';
import moment from 'moment';
import {
  debounceTime,
  filter,
  forkJoin,
  share,
  startWith,
  Subject,
  switchMap,
  takeUntil,
  tap,
} from 'rxjs';
import { MEDIA_TOKEN } from 'tockens';

@Component({
  selector: 'clever-headersearch',
  templateUrl: './headersearch.component.html',
  styleUrls: ['./headersearch.component.scss'],
  standalone: false,
})
export class HeadersearchComponent implements OnInit, OnDestroy {
  protected unsubscribe$ = new Subject();
  desktopTemplate: string = 'xl';
  mySearchControl = new FormControl();
  searchObj: any;
  searchres: any[] = [];
  isBrowser: boolean = false;
  partner: Partner;
  ops: string = '';
  placeholder: string = '';
  showglobalsearchres: boolean = false;
  loading: boolean = false;

  constructor(
    protected cdr: ChangeDetectorRef,
    protected searchService: SearchService,
    protected guardService: AuthGuardService,
    protected mediaObserver: BreakpointObserver,
    protected encservice: EncryptionService,
    protected router: Router,
    protected partnerService: PartnerService,
    protected translateService: TranslateService,
    @Inject(PLATFORM_ID) protected platformId: any,
    @Inject(DOCUMENT) protected document: any,
    @Optional() @Inject(MEDIA_TOKEN) private media_token: string,
  ) {
    this.isBrowser = isPlatformBrowser(this.platformId);
    this.desktopTemplate = this.media_token;
  }

  ngOnInit(): void {
    if (this.isBrowser) {
      this.initMedia();
      this.initPartner();
      this.cdr.detectChanges();
    }
  }

  async initPartner() {
    this.guardService.getPartner$
      .pipe(takeUntil(this.unsubscribe$))
      .subscribe((obj) => {
        if (obj?.partnerid?.length > 0) {
          this.partner = obj;
          for (let i = 0; i < this.partner?.agenturen?.length; i++) {
            if (this.partner?.agenturen[i]?.aktiv) {
              this.ops += this.partner?.agenturen[i]?.code + ',';
            }
          }
          this.initPartnerSearchParams();
          this.initplaceholder();
        }
      });
  }

  async initPartnerSearchParams() {
    this.partnerService
      .request({ partnerid: this.partner.partnerid }, 'getsearchparams')
      .pipe(takeUntil(this.unsubscribe$))
      .subscribe((res) => {
        if (res) {
          this.partner.hidecontentsearch = res.hidecontentsearch;
          this.partner.hidepauschalsearch = res.hidepauschalsearch;
          this.partner.hidehotelonlysearch = res.hidehotelonlysearch;
          this.partner.hideferiensearch = res.hideferiensearch;
          this.partner.hidecruisesearch = res.hidecruisesearch;
          this.partner.hidefalksearch = res.hidefalksearch;
          this.partner.hidejtsearch = res.hidejtsearch;
          this.partner.hidegolfsearch = res.hidegolfsearch;
          this.partner.hidegolfplatzsearch = res.hidegolfplatzsearch;
          this.partner.hidesktvsearch = res.hidesktvsearch;
          this.partner.hideflightsearch = res.hideflightsearch;
          this.partner.hiderailsearch = res.hiderailsearch;
          this.initSearchChange();
        }
      });
  }

  async initplaceholder() {
    this.placeholder = 'Reiseziel, Angebote';
    if (!this.partner.nosktv) {
      this.placeholder += ', Bestellnummer';
    }
    this.translateText();
    this.cdr.detectChanges();
  }

  async translateText() {
    if (!this.partner?.multilangualktiv) {
      return;
    }
    this.translateService.collect(this.placeholder, (translated) => {
      if (translated?.length > 0) {
        this.placeholder = translated;
      }
    });
    this.translateService.triggerTranslation(
      window.localStorage.getItem('current_language'),
    );
  }

  async initMedia() {
    if (this.mediaObserver.isMatched(Breakpoints.XSmall)) {
      this.desktopTemplate = 'xs';
    }
    if (this.mediaObserver.isMatched(Breakpoints.Small)) {
      this.desktopTemplate = 'sm';
    }
    if (this.mediaObserver.isMatched(Breakpoints.Medium)) {
      this.desktopTemplate = 'md';
    }
    if (this.mediaObserver.isMatched(Breakpoints.Large)) {
      this.desktopTemplate = 'lg';
    }
    if (this.mediaObserver.isMatched(Breakpoints.XLarge)) {
      this.desktopTemplate = 'xl';
    }
    this.cdr.detectChanges();
  }

  ngOnDestroy(): void {
    this.unsubscribe$.next(true);
    this.unsubscribe$.complete();
  }

  // detectPast(ev) {
  //     ev.stopPropagation();
  //     // ev.preventDefault();
  //     // this.mySearchControl.setValue(' ', { emitEvent: true, emitViewToModelChange: true });
  //     // this.cdr.detectChanges();
  //     // this.mySearchControl.setValue(ev.clipboardData.getData('text'), { emitEvent: true, emitViewToModelChange: true });
  //     this.cdr.detectChanges();
  // }

  initSearchChange(): void {
    const filterShare = this.mySearchControl.valueChanges.pipe(
      startWith(''),
      debounceTime(100),
      tap((value) => {
        this.loading = value?.length > 0;
        this.showglobalsearchres = false;
        this.cdr.detectChanges();
      }),
      filter((value) => typeof value === 'string' && value?.length >= 3),
      share(),
    );

    filterShare
      .pipe(
        takeUntil(this.unsubscribe$),
        debounceTime(300),
        switchMap((value) => forkJoin(this.getSearchTarget(value))),
      )
      .subscribe((res) => {
        // console.log(res);
        this.searchObj = res;
        this.sortSearchResult();
      });
  }

  getSearchTarget(value): any {
    const searchTarget = {
      pauschal: this.searchService.searchEntries(
        {
          searchValue: value,
          productType: 'pauschal',
          subTypeRegion: true,
          subTypeLocation: true,
          subTypeGiataHotel: true,
          subTypeCountry: true,
          tourOperatorList: this.ops,
          limit: 10,
        },
        'completions',
      ),
      hotelonly: this.searchService.searchEntries(
        {
          searchValue: value,
          productType: 'hotelonly',
          subTypeRegion: true,
          subTypeLocation: true,
          subTypeGiataHotel: true,
          subTypeCountry: true,
          tourOperatorList: this.ops,
          limit: 10,
        },
        'completions',
      ),
      flight: this.searchService.searchEntries(
        {
          searchValue: value,
          productType: 'flight',
          subTypeDestinationAirport: true,
          tourOperatorList: this.ops,
          limit: 10,
        },
        'completions',
      ),
      railtravel: this.searchService.searchEntries(
        {
          searchValue: value,
          productType: 'railtravel',
          subTypeRegion: true,
          subTypeLocation: true,
          subTypeGiataHotel: true,
          subTypeCountry: true,
          tourOperatorList: this.ops,
          limit: 10,
        },
        'completions',
      ),
      ferienhauser: this.searchService.searchEntries(
        {
          apikey: this.partner?.hometogo?.apikey,
          origin: this.partner?.hometogo?.origin,
          searchtarget: value,
          suffix: 'completion',
        },
        'completions/completionFerienhauser',
      ),
      tvangebote: this.searchService.searchEntries(
        {
          searchtarget: value,
          limit: 10,
        },
        'completions/completionTVAngebote',
      ),
      cruise: this.searchService.searchEntries(
        {
          searchtarget: value,
          ref: this.partner?.xt?.ref,
          limit: 10,
        },
        'completions/completionCruise',
      ),
      contents: this.searchService.searchEntries(
        {
          searchtarget: value,
          partnerid: this.partner.partnerid,
          active: true,
          limit: 10,
        },
        'completions/completionContent',
      ),
      jtHotels: this.searchService.searchEntries(
        {
          searchtarget: value,
          limit: 20,
        },
        'completions/completionJTHotel',
      ),
      golfHotels: this.searchService.searchEntries(
        {
          searchtarget: value,
          limit: 20,
        },
        'completions/completionGolfHotel',
      ),
      golfPlz: this.searchService.searchEntries(
        {
          searchtarget: value,
          limit: 20,
        },
        'completions/completionGolfPlz',
      ),
    };

    if (this.partner.hidecontentsearch) {
      delete searchTarget.contents;
    }

    if (this.partner.hidepauschalsearch) {
      delete searchTarget.pauschal;
    }

    if (this.partner.hidehotelonlysearch) {
      delete searchTarget.hotelonly;
    }

    if (this.partner.hidejtsearch) {
      delete searchTarget.jtHotels;
    }

    if (this.partner.hidegolfsearch) {
      delete searchTarget.golfHotels;
    }

    if (this.partner.hidegolfplatzsearch) {
      delete searchTarget.golfPlz;
    }

    if (
      this.partner?.partnerid !== 'jt' &&
      this.partner?.partnerid !== 'main' &&
      this.partner?.partnerid !== 'kurztrip' &&
      this.partner?.partnerid !== 'golfreisen'
    ) {
      delete searchTarget.jtHotels;
      delete searchTarget.golfHotels;
      delete searchTarget.golfPlz;
    }

    if (this.partner.hidepauschalsearch) {
      delete searchTarget.pauschal;
    }

    if (this.partner.hideflightsearch) {
      delete searchTarget.flight;
    }

    if (this.partner.hiderailsearch) {
      delete searchTarget.railtravel;
    }

    if (this.partner.nosktv || this.partner.hidesktvsearch) {
      delete searchTarget.tvangebote;
    }

    if (
      isNaN(Number(this.partner.xt?.ref)) ||
      Number(this.partner.xt?.ref) === 0 ||
      this.partner.hidecruisesearch
    ) {
      delete searchTarget.cruise;
    }

    if (this.partner.hideferiensearch || !this.partner?.hometogo?.active) {
      delete searchTarget.ferienhauser;
    }

    return searchTarget;
  }

  async sortSearchResult() {
    const reg = new RegExp('(' + this.mySearchControl.value + ')', 'gim');
    this.searchres = [];
    for (let i = 0; i < this.searchObj?.pauschal?.length; i++) {
      const index = this.searchres.findIndex(
        (obj) =>
          obj.name === this.searchObj?.pauschal[i].name &&
          obj?.subtext === this.searchObj?.pauschal[i]?.region?.name,
      );

      if (index >= 0) {
        this.searchres[index].isPauschal = true;
        this.searchres[index].pauschal = this.searchObj?.pauschal[i];
      } else {
        this.searchres.push({
          name: this.searchObj?.pauschal[i].name,
          displayname: String(this.searchObj?.pauschal[i].name).replace(
            reg,
            '<mark>$1</mark>',
          ),
          pauschal: this.searchObj?.pauschal[i],
          isPauschal: true,
          subtext:
            this.searchObj?.pauschal[i]?.region?.name ||
            this.searchObj?.pauschal[i]?.superRegion?.name ||
            '',
          score: this.searchObj?.pauschal[i].score,
        });
      }
    }

    // nur hotel
    for (let i = 0; i < this.searchObj?.hotelonly?.length; i++) {
      const index = this.searchres.findIndex(
        (obj) =>
          obj.name === this.searchObj?.hotelonly[i].name &&
          obj?.subtext === this.searchObj?.hotelonly[i]?.region?.name,
      );

      if (index >= 0) {
        this.searchres[index].isHotelonly = true;
        this.searchres[index].hotelonly = this.searchObj?.hotelonly[i];
      } else {
        this.searchres.push({
          name: this.searchObj?.hotelonly[i].name,
          displayname: String(this.searchObj?.hotelonly[i].name).replace(
            reg,
            '<mark>$1</mark>',
          ),
          hotelonly: this.searchObj?.hotelonly[i],
          isHotelonly: true,
          subtext:
            this.searchObj?.hotelonly[i]?.region?.name ||
            this.searchObj?.hotelonly[i]?.superRegion?.name ||
            '',
          score: this.searchObj?.hotelonly[i].score,
        });
      }
    }

    // railtravel
    for (let i = 0; i < this.searchObj?.railtravel?.length; i++) {
      const index = this.searchres.findIndex(
        (obj) => obj.name === this.searchObj?.railtravel[i].name,
      );

      if (index >= 0) {
        this.searchres[index].isRailtravel = true;
        this.searchres[index].railtravel = this.searchObj?.railtravel[i];
      } else {
        this.searchres.push({
          name: this.searchObj?.railtravel[i].name,
          displayname: String(this.searchObj?.railtravel[i].name).replace(
            reg,
            '<mark>$1</mark>',
          ),
          railtravel:
            this.searchObj?.pauschal[i]?.region?.name ||
            this.searchObj?.pauschal[i]?.superRegion?.name ||
            '',
          isRailtravel: true,
          subtext: this.searchObj?.railtravel[i]?.code,
          score: this.searchObj?.railtravel[i].score,
        });
      }
    }

    // flight
    for (let i = 0; i < this.searchObj?.flight?.length; i++) {
      const index = this.searchres.findIndex(
        (obj) => obj.name === this.searchObj?.flight[i].name,
      );

      if (index >= 0) {
        this.searchres[index].isFlight = true;
        this.searchres[index].isCarrent = true;
        this.searchres[index].flight = this.searchObj?.flight[i];
      } else {
        this.searchres.push({
          name: this.searchObj?.flight[i].name,
          displayname: String(this.searchObj?.flight[i].name).replace(
            reg,
            '<mark>$1</mark>',
          ),
          flight: this.searchObj?.flight[i],
          isFlight: true,
          isCarrent: true,
          subtext: this.searchObj?.flight[i]?.code,
          score: this.searchObj?.flight[i].score,
        });
      }
    }

    // ferienhauser
    for (let i = 0; i < this.searchObj?.ferienhauser?.length; i++) {
      const index = this.searchres.findIndex(
        (obj) => obj.name === this.searchObj?.ferienhauser[i].title,
      );

      if (index >= 0) {
        this.searchres[index].isFerienhauser = true;
        this.searchres[index].ferienhauser = this.searchObj?.ferienhauser[i];
      } else {
        this.searchres.push({
          name: this.searchObj?.ferienhauser[i].title,
          id: this.searchObj?.ferienhauser[i].id,
          displayname: String(this.searchObj?.ferienhauser[i].title).replace(
            reg,
            '<mark>$1</mark>',
          ),
          ferienhauser: this.searchObj?.ferienhauser[i],
          isFerienhauser: true,
          subtext: '',
          score: this.searchObj?.ferienhauser[i].score,
        });
      }
    }

    // cruise
    for (let i = 0; i < this.searchObj?.cruise?.length; i++) {
      const index = this.searchres.findIndex(
        (obj) => obj.name === this.searchObj?.cruise[i].name,
      );

      if (index >= 0) {
        this.searchres[index].isCruise = true;
        this.searchres[index].cruise = this.searchObj?.cruise[i];
      } else {
        this.searchres.push({
          name: this.searchObj?.cruise[i].name,
          displayname: String(this.searchObj?.cruise[i].name).replace(
            reg,
            '<mark>$1</mark>',
          ),
          cruise: this.searchObj?.cruise[i],
          isCruise: true,
          subtext: '',
          score: this.searchObj?.cruise[i].score,
        });
      }
    }

    // contents
    for (let i = 0; i < this.searchObj?.contents?.length; i++) {
      const tmp_name =
        this.searchObj?.contents[i].title?.length > 0
          ? this.searchObj?.contents[i].title
          : this.searchObj?.contents[i].pathname;
      this.searchres.push({
        // name: this.searchObj?.contents[i].title,
        name: tmp_name,
        displayname: String(tmp_name).replace(reg, '<mark>$1</mark>'),
        description: this.searchObj?.contents[i].description,
        content: this.searchObj?.contents[i],
        isContent: true,
        subtext:
          this.searchObj?.contents[i].description?.length > 200
            ? this.searchObj?.contents[i].description.slice(0, 200) + '...'
            : this.searchObj?.contents[i].description,
        score: this.searchObj?.contents[i].score,
      });
    }

    // tvangebote
    for (let i = 0; i < this.searchObj?.tvangebote?.length; i++) {
      this.searchres.push({
        // name: this.searchObj?.contents[i].title,
        name: this.searchObj?.tvangebote[i].name,
        sktvbestellnummer: String(
          'SkTV Bestellnummer: ' + this.searchObj?.tvangebote[i].id,
        ).replace(reg, '<mark>$1</mark>'),
        displayname: String(this.searchObj?.tvangebote[i].name).replace(
          reg,
          '<mark>$1</mark>',
        ),
        id: this.searchObj?.tvangebote[i].id,
        location: this.searchObj?.tvangebote[i].location,
        tvangebote: this.searchObj?.tvangebote[i],
        isTvangebote: true,
        subtext: this.searchObj?.tvangebote[i].location,
        score: this.searchObj?.tvangebote[i].score,
      });
    }

    // golfPlz
    for (let i = 0; i < this.searchObj?.golfPlz?.length; i++) {
      this.searchres.push({
        name: this.searchObj?.golfPlz[i].searchname,
        GolfplatzID: String(
          'Golfplatz: ' + this.searchObj?.golfPlz[i].GolfplatzID,
        ).replace(reg, '<mark>$1</mark>'),
        displayname: String(this.searchObj?.golfPlz[i].searchname).replace(
          reg,
          '<mark>$1</mark>',
        ),
        id: this.searchObj?.golfPlz[i].GolfplatzID,
        isGolfplatz: true,
        subtext: this.searchObj?.golfPlz[i].region,
        score: this.searchObj?.golfPlz[i].score,
        UrlName: this.searchObj?.golfPlz[i].UrlName,
      });
    }

    // golfHotels
    for (let i = 0; i < this.searchObj?.golfHotels?.length; i++) {
      this.searchres.push({
        name: this.searchObj?.golfHotels[i].searchname,
        HotelID: String(
          'Golfplatz: ' + this.searchObj?.golfHotels[i].HotelID,
        ).replace(reg, '<mark>$1</mark>'),
        displayname: String(this.searchObj?.golfHotels[i].searchname).replace(
          reg,
          '<mark>$1</mark>',
        ),
        id: this.searchObj?.golfHotels[i].HotelID,
        isGolfHotels: true,
        subtext: this.searchObj?.golfHotels[i].region,
        score: this.searchObj?.golfHotels[i].score,
        UrlName: this.searchObj?.golfHotels[i].UrlName,
      });
    }

    // jtHotels
    for (let i = 0; i < this.searchObj?.jtHotels?.length; i++) {
      this.searchres.push({
        name: this.searchObj?.jtHotels[i].searchname,
        HotelID: String(
          'Golfplatz: ' + this.searchObj?.jtHotels[i].HotelID,
        ).replace(reg, '<mark>$1</mark>'),
        displayname: String(this.searchObj?.jtHotels[i].searchname).replace(
          reg,
          '<mark>$1</mark>',
        ),
        id: this.searchObj?.jtHotels[i].HotelID,
        isJtHotels: true,
        subtext: this.searchObj?.jtHotels[i].region,
        score: this.searchObj?.jtHotels[i].score,
        UrlName: this.searchObj?.jtHotels[i].UrlName,
      });
    }

    this.searchres.sort((a, b) => b.score - a.score);
    // console.log(this.searchres);
    this.showglobalsearchres = true;
    this.loading = false;
    this.cdr.detectChanges();
  }

  gotoSearch(ev) {
    ev?.stopPropagation();
    if (this.mySearchControl.value?.length >= 3) {
      const navigationExtras: NavigationExtras = {
        queryParams: {
          params: this.encservice.encrypt({
            searchtarget: this.mySearchControl.value,
          }),
        },
      };
      const url = this.router
        .createUrlTree(['search'], navigationExtras)
        .toString();
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('visibility', 'hidden');
      link.click();
    }
  }

  gotofirst(item, ev) {
    // console.log(item)
    if (item.isJtHotels) {
      this.gotoJtHotel(item, ev);
    } else if (item.isGolfHotels) {
      this.gotoGolfHotel(item, ev);
    } else if (item.isGolfplatz) {
      this.gotoGolfPlz(item, ev);
    } else if (item.isPauschal) {
      this.gotoPauschal(item, ev);
    } else if (item.isHotelonly) {
      this.gotoHotel(item, ev);
    } else if (item.isRailtravel) {
      this.gotoRail(item, ev);
    } else if (item.isFlight) {
      this.gotoFlight(item, ev);
    } else if (item.isCarrent) {
      this.gotoCarrent(item, ev);
    } else if (item.isCruise) {
      this.gotoCruise(item, ev);
    } else if (item.isFerienhauser) {
      this.gotoFerienhauser(item, ev);
    } else if (item.isContent) {
      this.gotoContent(item, ev);
    } else if (item.isTvangebote) {
      this.gotoSktv(item, ev);
    }
  }

  gotoGolfPlz(obj, ev) {
    ev?.stopPropagation();
    // console.log(obj);
    // this.router.createUrlTree(['golfplatz', this.data.UrlName], {}).toString()
    const url = this.router
      .createUrlTree(['golfplatz', obj.UrlName], {})
      .toString();
    const link = document.createElement('a');
    link.href = url;
    link.setAttribute('visibility', 'hidden');
    link.click();
  }

  gotoGolfHotel(obj, ev) {
    ev?.stopPropagation();
    // console.log(obj);
    // this.router.createUrlTree(['golfplatz', this.data.UrlName], {}).toString()
    const url = this.router
      .createUrlTree(['hotel', obj.UrlName], {})
      .toString();
    const link = document.createElement('a');
    link.href = url;
    link.setAttribute('visibility', 'hidden');
    link.click();
  }

  gotoJtHotel(obj, ev) {
    ev?.stopPropagation();
    // console.log(obj);
    // this.router.createUrlTree(['golfplatz', this.data.UrlName], {}).toString()
    const url = this.router
      .createUrlTree(['hotel', obj.UrlName], {})
      .toString();
    const link = document.createElement('a');
    link.href = url;
    link.setAttribute('visibility', 'hidden');
    link.click();
  }

  async gotoSktv(obj, ev) {
    ev?.stopPropagation();
    const navigationExtras: NavigationExtras = {
      queryParams: {
        params: this.encservice.encrypt({ extra: { orderId: obj.id } }),
      },
    };
    const url = this.router
      .createUrlTree(['sktv'], navigationExtras)
      .toString();
    const link = document.createElement('a');
    link.href = url;
    link.setAttribute('visibility', 'hidden');
    link.click();
  }

  gotoContent(obj, ev) {
    ev?.stopPropagation();
    // console.log(obj);
    if (obj?.content?.path?.length > 0 && obj?.content?.pathname?.length > 0) {
      const url =
        'https://' +
        (this.document.domain === 'localhost'
          ? 'localhost:4200'
          : this.document.domain) +
        obj?.content?.path +
        '/' +
        obj?.content?.pathname;
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('visibility', 'hidden');
      link.click();
    }
  }

  gotoCruise(obj, ev) {
    ev?.stopPropagation();
    // console.log(obj);

    const myKrzfilters = {} as KreuzfahrtFilters;
    const today = new Date();
    myKrzfilters.productType = 'kreuzfahrt';
    myKrzfilters.cruisesuchetype = '';
    myKrzfilters.cruiseduration = '';
    myKrzfilters.cruisemaxanzpass = '';
    myKrzfilters.cruiseboardlanguage = '';
    myKrzfilters.cruisemaxprice = '';
    myKrzfilters.cruisecabincat = '';
    myKrzfilters.reference = this.partner.xt.ref;
    myKrzfilters.cruisestarthafen = null;
    myKrzfilters.cruisezielhafen = null;
    myKrzfilters.airports = null;
    myKrzfilters.cruisemaxanzpass = '';
    if (obj.cruise?.isRegion) {
      myKrzfilters.cruiseregion = [obj.cruise];
    }
    if (obj.cruise?.isCompany) {
      myKrzfilters.cruisecompanys = [obj.cruise];
    }
    myKrzfilters.reisedauerResult = {
      value: '7',
      name: '1 Woche',
    };
    myKrzfilters.reisendeResult = {
      adults: 2,
      children: [],
    };

    myKrzfilters.reisezeitraumResult = {
      start: new Date(today.setDate(today.getDate() + 14)).toISOString(),
      end: new Date(today.setDate(today.getDate() + 30)).toISOString(),
    };

    const url = this.router
      .createUrlTree(['cruise'], {
        queryParams: {
          params: this.encservice.encrypt(myKrzfilters),
          replaceUrl: true,
        },
      })
      .toString();
    const link = document.createElement('a');
    link.href = url;
    link.setAttribute('visibility', 'hidden');
    link.click();
  }

  gotoCarrent(obj, ev) {
    const objFilter = {} as CarrentFilters;
    ev?.stopPropagation();
    // console.log(obj);

    objFilter.productType = 'carrent';
    objFilter.searchDate = '1, 30';
    objFilter.startNum = 1;
    objFilter.endNum = 99;
    objFilter.adults = '2';
    objFilter.startTime = '12:00';
    objFilter.endTime = '12:00';
    objFilter.arrivalAirportList = obj.flight;
    const url = this.router
      .createUrlTree(['carrent'], {
        queryParams: {
          params: this.encservice.encrypt(objFilter),
          replaceUrl: true,
        },
      })
      .toString();
    const link = document.createElement('a');
    link.href = url;
    link.setAttribute('visibility', 'hidden');
    link.click();
  }

  gotoFlight(obj, ev) {
    ev?.stopPropagation();
    // console.log(obj);
    const realparams = {} as ParamFilters;
    realparams.productType = 'flight';
    realparams.reisezeitraumResult = {
      start: moment().add(4, 'days').format('YYYY-MM-DD'),
      end: moment().add(180, 'days').format('YYYY-MM-DD'),
      minDuration: 1,
      maxDuration: 99,
    };

    realparams.reisendeResult = {
      adults: 2,
      children: [],
    };

    realparams.reisedauerResult = {
      name: 'Beliebige',
      minDuration: '1',
      maxDuration: '30',
    };
    realparams.arrivalAirportList = [obj.flight];

    const url = this.router
      .createUrlTree(['flugs'], {
        queryParams: {
          params: this.encservice.encrypt(realparams),
          replaceUrl: true,
        },
      })
      .toString();
    const link = document.createElement('a');
    link.href = url;
    link.setAttribute('visibility', 'hidden');
    link.click();
  }

  gotoRail(obj, ev) {
    ev?.stopPropagation();
    // console.log(obj);
    const realparams = {} as ParamFilters;
    realparams.productType = 'railtravel';
    realparams.reisezeitraumResult = {
      start: moment().add(4, 'days').format('YYYY-MM-DD'),
      end: moment().add(180, 'days').format('YYYY-MM-DD'),
      minDuration: 1,
      maxDuration: 99,
    };

    realparams.reisendeResult = {
      adults: 2,
      children: [],
    };

    realparams.reisedauerResult = {
      name: 'Beliebige',
      minDuration: '1',
      maxDuration: '30',
    };
    realparams.israiltravel = true;
    realparams.pauschalreiseResult = {
      type: obj.railtravel.type,
      data: {
        name: obj.railtravel.name,
        code: obj.railtravel.code,
      },
    };

    const url = this.router
      .createUrlTree(['hotellist'], {
        queryParams: {
          params: this.encservice.encrypt(realparams),
          replaceUrl: true,
        },
      })
      .toString();
    const link = document.createElement('a');
    link.href = url;
    link.setAttribute('visibility', 'hidden');
    link.click();
  }

  gotoHotel(obj, ev) {
    ev?.stopPropagation();
    // console.log(obj);
    const realparams = {} as ParamFilters;
    realparams.productType = 'hotelonly';
    realparams.reisezeitraumResult = {
      start: moment().add(4, 'days').format('YYYY-MM-DD'),
      end: moment().add(180, 'days').format('YYYY-MM-DD'),
      minDuration: 1,
      maxDuration: 30,
    };

    realparams.reisendeResult = {
      adults: 2,
      children: [],
    };

    realparams.reisedauerResult = {
      name: 'Beliebige',
      minDuration: '1',
      maxDuration: '30',
    };
    realparams.pauschalreiseResult = {
      type: obj.hotelonly.type,
      data: {
        name: obj.hotelonly.name,
        code: obj.hotelonly.code,
      },
    };

    const url = this.router
      .createUrlTree(['hotellist'], {
        queryParams: {
          params: this.encservice.encrypt(realparams),
          replaceUrl: true,
        },
      })
      .toString();
    const link = document.createElement('a');
    link.href = url;
    link.setAttribute('visibility', 'hidden');
    link.click();
  }

  gotoPauschal(obj, ev) {
    ev?.stopPropagation();
    // console.log(obj);

    const realparams = {} as ParamFilters;
    realparams.productType = 'pauschal';
    realparams.reisezeitraumResult = {
      start: moment().add(4, 'days').format('YYYY-MM-DD'),
      end: moment().add(180, 'days').format('YYYY-MM-DD'),
      minDuration: 1,
      maxDuration: 99,
    };

    realparams.reisendeResult = {
      adults: 2,
      children: [],
    };

    realparams.reisedauerResult = {
      name: 'Beliebige',
      minDuration: '1',
      maxDuration: '30',
    };
    realparams.pauschalreiseResult = {
      type: obj.pauschal.type,
      data: {
        name: obj.pauschal.name,
        code: obj.pauschal.code,
      },
    };

    const url = this.router
      .createUrlTree(['hotellist'], {
        queryParams: {
          params: this.encservice.encrypt(realparams),
          replaceUrl: true,
        },
      })
      .toString();
    const link = document.createElement('a');
    link.href = url;
    link.setAttribute('visibility', 'hidden');
    link.click();
  }

  gotoFerienhauser(obj, ev) {
    ev?.stopPropagation();
    // console.log(obj);

    const myferienfilters = {} as FerienFIlters;
    myferienfilters.productType = 'ferienhauser';
    myferienfilters.reisezielResult = {
      id: obj.ferienhauser.id,
      title: obj.ferienhauser.title,
    };
    myferienfilters.minPrice = 9;
    myferienfilters.maxPrice = 1000;

    myferienfilters.bedrooms = 1;
    myferienfilters.toCenter = null;
    myferienfilters.toWater = null;
    myferienfilters.toSki = null;
    myferienfilters.rating = null;

    myferienfilters.adults = 2;
    myferienfilters.children = 0;
    myferienfilters.childrenAges = [];

    myferienfilters.dauer = '7';
    myferienfilters.start = moment().add(4, 'days').format('YYYY-MM-DD');
    myferienfilters.end = moment().add(180, 'days').format('YYYY-MM-DD');
    const url = this.router
      .createUrlTree(['ferienhause'], {
        queryParams: {
          params: this.encservice.encrypt(myferienfilters),
          replaceUrl: true,
        },
      })
      .toString();
    const link = document.createElement('a');
    link.href = url;
    link.setAttribute('visibility', 'hidden');
    link.click();
  }
}
